import produce from 'immer';
import {
  UsersState,
  ApplicationAction,
  LOAD_USERS_ERROR,
  LOAD_USERS_REQUEST,
  LOAD_USERS_SUCCESS
} from 'store/types';

export const initialState: UsersState = {
  loading: {
    users: false
  },
  current_page: 1,
  total: 1,
  last_page: 1,
  users: []
};

const reducer = (state = initialState, action: ApplicationAction) => {
  switch (action.type) {
    case LOAD_USERS_REQUEST:
      return produce(state, (draft) => {
        draft.loading.users = true;
      });
    case LOAD_USERS_SUCCESS:
      const { current_page, total, data, last_page } = action.data;
      return produce(state, (draft) => {
        draft.loading.users = false;
        draft.users = data;
        draft.current_page = current_page;
        draft.last_page = last_page;
        draft.total = total;
      });
    case LOAD_USERS_ERROR:
      return produce(state, (draft) => {
        draft.loading.users = false;
      });
    default:
      return state;
  }
};

export default reducer;
